/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CityStateLookupDataModelApiModel } from '../../models/city-state-lookup-data-model-api-model';

export interface GetStateAndCity$Params {
  stateId: string;
  city: any;
}

export function getStateAndCity(http: HttpClient, rootUrl: string, params: GetStateAndCity$Params, context?: HttpContext): Observable<StrictHttpResponse<CityStateLookupDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, getStateAndCity.PATH, 'get');
  if (params) {
    rb.path('stateId', params.stateId, {});
    rb.path('city', params.city, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CityStateLookupDataModelApiModel>;
    })
  );
}

getStateAndCity.PATH = '/v1/lookup/city/{stateId}/{city}';
